import { Component } from '@angular/core';

@Component({
    selector: 'error-500',
    templateUrl: 'error-500.html'
})
export class Error500Component {}
